// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  areas: [],
  area: {}
}

export const mutations = {
  SET_AREAS(state, areas) {
    state.areas = areas
  },
  SET_AREA(state, area) {
    state.area = area
  },
  ADD_AREA(state, area) {
    state.areas.push(area)
  },
  EDIT_AREA(state, area) {
    const index = state.areas.findIndex(el => el.area_uuid === area.area_uuid)
    if (index !== -1) {
      state.areas.splice(index, 1, area)
    }
  },
  DELETE_AREA(state, area_uuid) {
    const index = state.areas.findIndex(el => el.area_uuid === area_uuid)
    if (index !== -1) state.areas.splice(index, 1)
  }
}

export const actions = {
  fetchAreas({ commit }, payload) {
    return ApiService.fetchAreas(payload)
      .then(res => {
        const areas = res.data.data
        commit('SET_AREAS', areas)
      })
      .catch(error => {
        throw error
      })
  },
  fetchArea({ commit, getters, state }, area_uuid) {
    if (state.area.area_uuid === area_uuid) {
      return state.area
    }

    const area = getters.getAreaByUUID(area_uuid)

    if (area) {
      commit('SET_AREA', area)
      return area
    } else {
      return ApiService.fetchArea(area_uuid)
        .then(res => {
          const area = res.data
          commit('SET_AREA', area)
          return area
        })
        .catch(error => {
          throw error
        })
    }
  },
  addArea({ commit }, payload) {
    return ApiService.addArea(payload)
      .then(res => {
        const area = res.data
        commit('ADD_AREA', area)
      })
      .catch(error => {
        throw error
      })
  },
  editArea({ commit }, payload) {
    return ApiService.editArea(payload)
      .then(res => {
        const area = res.data
        commit('EDIT_AREA', area)
      })
      .catch(error => {
        throw error
      })
  },
  deleteArea({ commit }, payload) {
    return ApiService.deleteArea(payload)
      .then(() => {
        commit('DELETE_AREA', payload.area_uuid)
      })
      .catch(error => {
        throw error
      })
  }
}

export const getters = {
  getAreaByUUID: state => uuid => {
    return state.areas.find(el => el.area_uuid === uuid)
  }
}
